import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

//History
import history from "./_Utils/History";

//Routes
import { HOME, CURRENCY, STATS, EXCHANGE, NEWS } from "./_Utils/Routes";

//Action
import { NavTab } from "../Actions";

import Logo from "../Assets/logo.svg";

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 1,
    };
  }

  componentDidMount() {
    if (
      history?.location?.pathname.includes(CURRENCY) ||
      history?.location?.pathname.includes("currency")
    ) {
      this.setState({
        activeTab: 2,
      });
      return;
    }

    if (history?.location?.pathname.includes(STATS)) {
      this.setState({
        activeTab: 3,
      });
      return;
    }

    if (history?.location?.pathname.includes(EXCHANGE)) {
      this.setState({
        activeTab: 4,
      });
      return;
    }

    if (history?.location?.pathname.includes(NEWS)) {
      this.setState({
        activeTab: 5,
      });
      return;
    }
  }

  componentDidUpdate(prevProps, nextState) {
    if (prevProps.tab !== this.props.tab) {
      this.setState({
        activeTab: this.props.tab,
      });
    }
  }

  // set nav tabs or pages
  handelActiveTab = (activeTab) => {
    this.props.NavTab(activeTab);
  };

  render() {
    return (
      <div className="Navbar">
        <div className="Navbar_container">
          {/* navbar logo */}
          <div className="Navbar_Logo">
            <img src={Logo} alt="logo" />
          </div>

          {/* navbar button */}
          <input type="checkbox" id="navbar-toggle" className="Navbar_toggle" />
          <label htmlFor="navbar-toggle" className="Navbar_btn">
            <div className="Navbar_bar"></div>
            <div className="Navbar_bar"></div>
            <div className="Navbar_bar"></div>
          </label>

          {/* navbar tabs */}
          <div className="Navbar_tabs">
            <Link
              className={
                this.state.activeTab === 1
                  ? "Navbar_tabs_item active"
                  : "Navbar_tabs_item"
              }
              to={HOME}
              onClick={() => {
                this.handelActiveTab(1);
              }}
            >
              HOME
            </Link>
            <Link
              className={
                this.state.activeTab === 2
                  ? "Navbar_tabs_item active"
                  : "Navbar_tabs_item"
              }
              to={CURRENCY}
              onClick={() => {
                this.handelActiveTab(2);
              }}
            >
              CURRENCY
            </Link>
            <Link
              className={
                this.state.activeTab === 3
                  ? "Navbar_tabs_item active"
                  : "Navbar_tabs_item"
              }
              to={STATS}
              onClick={() => {
                this.handelActiveTab(3);
              }}
            >
              STATS
            </Link>
            <Link
              className={
                this.state.activeTab === 4
                  ? "Navbar_tabs_item active"
                  : "Navbar_tabs_item"
              }
              to={EXCHANGE}
              onClick={() => {
                this.handelActiveTab(4);
              }}
            >
              EXCHANGE
            </Link>
            <Link
              className={
                this.state.activeTab === 5
                  ? "Navbar_tabs_item active"
                  : "Navbar_tabs_item"
              }
              to={NEWS}
              onClick={() => {
                this.handelActiveTab(5);
              }}
            >
              NEWS
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tab: state.appData.tab,
  };
};

export default connect(mapStateToProps, {
  NavTab,
})(Navbar);
